export const DatiqFontFamily = 'Sequel Sans, Helvetica, Arial, Sans-Serif';
export type DatiqFontFamilyWeight =
    | 'normal'
    | 'bold'
    | 'bolder'
    | 'lighter'
    | '100'
    | '200'
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '900';

export interface IDatiqFontFamily {
    fontFamily: string;
    fontStyle: string;
    fontWeight: DatiqFontFamilyWeight;
    fontSize: number | string;
    lineHeight: number | string;
    letterSpacing: number | string;
}

export const datiqFontFamilyCaption: Partial<IDatiqFontFamily> = {
    fontFamily: 'Sequal Sans',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0.2,
};
